import React from 'react';
import { connect } from 'react-redux';
import { appConfigActions } from './redux/root-action';
import { fetchConfig } from '@trp-ta-nitro/auth-react';

class AppConfigLoader extends React.Component<{
  appConfig: any;
  loadConfig: any;
  configs: Array<string>;
  children: JSX.Element;
}, any> {
  componentDidMount() {
    const { loadConfig, configs } = this.props;
    fetchConfig(configs).then((appConfig: any) => {
      loadConfig(appConfig);
    });
  }

  render() {
    const { appConfig } = this.props;

    if (!appConfig.apiKey) {
      return true;
    }

    return <>{this.props.children}</>;
  }
}

export default connect(
  ({ appConfig }: any) => ({
    appConfig,
  }),
  { loadConfig: appConfigActions.loadConfig },
)(AppConfigLoader);
